import React from 'react';
import stylesheet from './Tags.scss';
import Tag from '../Tag';

export class Tags extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isExpanded: false };
  }

  toggleExpandedStatus = () => {
    this.setState({ isExpanded: !this.state.isExpanded });
  };

  renderCollapsedStatus = () => {
    const { as, tags, limit, altMoreText, url, onClick } = this.props;

    const remainingTags = tags.slice(limit, tags.length);

    if (onClick && remainingTags && remainingTags.length > 0) {
      return (
        <li>
          <Tag
            as={as}
            onClick={this.toggleExpandedStatus}
            altMoreText={altMoreText}
          >
            + {remainingTags.length}
          </Tag>
        </li>
      );
    } else if (url && remainingTags && remainingTags.length > 0) {
      return (
        <li>
          <Tag as={as} url={url} altMoreText={altMoreText}>
            + {remainingTags.length}
          </Tag>
        </li>
      );
    }
    return null;
  };

  renderExpandedStatus = () => {
    const { as, tags, limit } = this.props;
    const remainingTags = tags.slice(limit, tags.length);

    if (!tags) {
      return null;
    }

    return remainingTags.map((tag, index) => {
      return (
        <li key={index}>
          <Tag as={as}>{tag}</Tag>
        </li>
      );
    });
  };

  renderVisible = () => {
    const { as, tags, limit } = this.props;
    const visibileTags = tags.slice(0, limit);

    if (!tags) {
      return null;
    }

    return visibileTags.map((tag, index) => {
      return (
        <li key={index}>
          <Tag as={as}>{tag}</Tag>
        </li>
      );
    });
  };

  render() {
    const { isExpanded } = this.state;

    return (
      <ul className={stylesheet.tags}>
        {this.renderVisible()}
        {isExpanded
          ? this.renderExpandedStatus()
          : this.renderCollapsedStatus()}
      </ul>
    );
  }
}

export default Tags;
